import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const StoresDetailPage = lazy(() => import('./StoresDetail.page'));

export const StoresDetail = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <StoresDetailPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
